module.exports = __webpack_public_path__ + "static/media/logo2.42f28480.png";